/**
 * Step 5 In funnel
 * View and print report
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom"; 
import { useSelector, useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';
import {
  AppBar, Toolbar, Typography, Drawer, Box, Select, MenuItem, Stack,
  FormControl, TextField, InputLabel, Button, IconButton,
  Grid, Card, CssBaseline, Container, Checkbox,
  Tabs, Tab, ButtonGroup, Menu,
  List, ListItem, ListItemText, ListItemAvatar, ListItemButton, Divider, Avatar
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import html2canvas from 'html2canvas';

import Header from '../../components/Header';

import {
  getSurveysIntersectingCylinder,
  metersToDegrees,
  generateSimpleDirectionalSurvey,
  generateFpzPolygon
} from '../../common/functions';
import { fpzActions } from '../../actions';

import LibraryView from '../../components/LibraryView';

const drawerWidth = 240;

const containerStyle = {
  width: '100vw',
  height: '100vh',
  position: 'relative'
};

const mapContainerStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 1
};

const ReportPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const authState = useSelector(state => state.authReducer);
  const userState = useSelector(state => state.userReducer);
  const { user } = userState;

  const [fpzReports, setFpzReports] = useState([]);
  const [listView, setListView] = useState([]);

  const fetchFpzReports = async () => {
    const params = {
      user_id: authState?.profile?.userId,
    }
    /*const response = await fpzActions.getFpzReports(params);
    if (response) {
      console.log('Fetched FPZ Reports:', response);
      setFpzReports(response);
    }*/

    const response2 = await fpzActions.getFpzFoldersAndReports(params);
    console.log('repsonse2', response2)
    if (response2) {
      setListView(response2);
    }
  };

  useEffect(() => {

    fetchFpzReports();

    
  }, []);

  const handleViewReport = async (fpzReport) => {
    console.log('View Report:', fpzReport);
    if (!fpzReport) {
      console.error('No report details found');
      return;
    }
    await dispatch({
      type: 'SET_CURRENT_FPZ_REPORT', payload: {
        ...fpzReport?.report_details,
        fpz_report_id: fpzReport?.fpz_report_id || null,
        report_name: fpzReport?.report_name || '', 
        report_description: fpzReport?.report_description || ''
      }
    });
    navigate(`/report`);
  };

  return (
    <Box >
      <h3>Saved FPZ Reports</h3>
      {/*
      <Card id="cube-card" sx={{ flex: 1, height: '100%' }}>
        <Box sx={{ position: 'relative',  height: '100%', p: 2 }}>
          <List sx={{ width: '100%' }}>
            {fpzReports?.map((report, index) => (
              <>
                <ListItem
                  alignItems="flex-start"
                  key={index}
                  secondaryAction={
                    <IconButton aria-label="comment">
                      <Button
                        variant="outlined"
                        color="info"
                        onClick={() => handleViewReport(report)}
                      >
                        View/Edit
                      </Button>
                    </IconButton>
                  }
                >
                  <ListItemAvatar>
                    <Avatar
                      alt="Remy Sharp"
                      src={report?.report_details?.reportImages?.mapImage || '/static/images/avatar/1.jpg'}
                      sx={{ width: 50, height: 50 }}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={report?.report_name || 'Untitled Report'}
                    secondary={
                      <React.Fragment>
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{ color: 'text.primary', display: 'inline' }}
                        >
                          
                        </Typography>
                        {report?.report_description || ''}
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider variant="inset" component="li" />
              </>
            ))}
            
          </List>
        </Box>
      </Card>*/}

      <LibraryView rows={ listView?.rows || []} />
    </Box>

  );
};

export default ReportPage;

















